export default __webpack_public_path__ + "381fabe12c76f5fd34b3c863fe7f4e4f.png";